/**
 * Hook che indica la presenza di errori o warning nelle strutture passate in input
 * @param {*} validare
 * @param {*} dirty
 * @param {*} validazione
 * @returns oggetto con hasError e HasWarning
 */
function useValidations(validare, dirty, validazione) {
  const validareDirty = validare || dirty;
  const hasError = !validazione.valid && validareDirty;
  const hasWarning = !hasError && validazione.warnings && validazione.warnings.length > 0 && validareDirty;
  return ({
    hasError,
    hasWarning,
  });
}

export default useValidations;
